<template>
  <div id="flashdeal-privilege-campaign-list">
    <b-card no-body class="p-2 container-card mb-1">
      <b-row>
        <b-col cols="12">
          <div>
            <div class="d-flex justify-content-end mb-1">
              <add-button
                :btn-label="'Campaign'"
                @click.native="
                  () => {
                    $router
                      .push(`/flashdeal/privilege/campaign/create`)
                      .catch(() => {});
                  }
                "
              />
              <export-button class="ml-2" @onExport="onOpenExportModal" />
            </div>
            <div class="d-flex flex-wrap justify-content-end">
              <div class="mr-1 ml-1 mb-1">
                <v-select
                  id="campaign-type-status"
                  class="v-select-filter bg-document-list bg-dropdown"
                  :class="status ? 'v-select-filter-selected' : null"
                  placeholder="Status"
                  :options="statusOption"
                  @input="(option) => onSelectFilter('status', option)"
                />
              </div>

              <div class="search-container mb-1">
                <search :on-search-input="onSetValueSearch" />
              </div>
            </div>
          </div>
        </b-col>
        <!--  -->
        <b-col cols="12" class="mb-1">
          <overlay-loading :loading="loading.tableData">
            <template #content>
              <b-table
                :fields="fields"
                :items="privilegeCampaignList.payload"
                responsive
                bordered
                borderless
                sticky-header
                show-empty
                class="default-static-table"
              >
                <template #head(seq)="data">
                  <div class="text-center">
                    {{ data.label }}
                  </div>
                </template>
                <template #cell(seq)="data">
                  <div class="text-center">
                    {{ data.item.seq }}
                  </div>
                </template>
                <template #head(campaign_image_url)="data">
                  <div class="text-center">
                    {{ data.label }}
                  </div>
                </template>
                <template #cell(campaign_image_url)="data">
                  <div class="text-center">
                    <img :src="data.value || DefaultImg" class="image-column" />
                  </div>
                </template>
                <template #head(name_th)="data">
                  <div class="text-left">
                    {{ data.label }}
                  </div>
                </template>
                <template #head(section)="data">
                  <div class="text-left">
                    {{ data.label }}
                  </div>
                </template>
                <template #cell(valid_from)="data">
                  <span>{{
                    data.item.valid_from
                      ? resolveDateWithSeperator(data.item.valid_from) +
                        " " +
                        resolveTime(data.item.valid_from)
                      : "-"
                  }}</span>
                </template>
                <template #cell(valid_through)="data">
                  <span>{{
                    data.item.valid_through
                      ? resolveDateWithSeperator(data.item.valid_through) +
                        " " +
                        resolveTime(data.item.valid_through)
                      : "-"
                  }}</span>
                </template>
                <template #cell(status)="data">
                  <b-form-checkbox
                    field-value="true"
                    class="custom-control-success custom-toggle w-50px"
                    name="check-button"
                    switch
                    :checked="data.item.status == 1"
                    @change="changeCampaignStatus(data.item.campaignid, $event)"
                  >
                    <span class="switch-icon-left toggle-text">{{ "" }}</span>
                    <span class="switch-icon-right toggle-text">{{ "" }}</span>
                  </b-form-checkbox>
                </template>
                <template #cell(actions)="data">
                  <div class="cursor-pointer">
                    <div class="d-flex justify-content-center">
                      <b-button
                        v-b-tooltip.hover
                        title="Edit"
                        variant="secondary"
                        class="default-btn-action mr-2"
                        @click="
                          $router
                            .push(
                              `/flashdeal/privilege/campaign/info/${data.item.campaignid}/${data.item.alt_reference}`
                            )
                            .catch(() => {})
                        "
                      >
                        <edit-icon
                          class="default-btn-action-svg iconEdit-btn"
                        />
                      </b-button>
                      <b-button
                        v-b-tooltip.hover
                        title="Delete"
                        variant="secondary"
                        class="default-btn-action mr-4 iconSvg-btn"
                        @click="removeCampaign(data.item.campaignid)"
                      >
                        <delete-icon class="default-btn-action-svg" />
                      </b-button>
                    </div>
                  </div>
                </template>
                <template #empty>
                  <card-no-item :text-no-img="'Item Not Found'" />
                </template>
              </b-table>
            </template>
          </overlay-loading>
        </b-col>
        <!--  -->
        <b-col cols="12">
          <pagination-with-reorder
            entity-editable
            :pagination="pagination"
            @entityChange="onFilterEntity"
            @pageChange="onPageChange"
          />
        </b-col>
      </b-row>
    </b-card>
    <history-report-modal
      v-if="modalPopup.report"
      @onCloseModal="closeReportModal"
      :moduleTypeKey="defaultReportFilterType.module"
      :moduleKey="defaultReport.flash_deal"
    />
  </div>
</template>

<script>
import Search from "@/views/components/search/Search.vue";
import vSelect from "vue-select";
import EditIcon from "@/@core/components/svg/common/Edit.vue";
import DeleteIcon from "@/@core/components/svg/common/Trash.vue";
import DefaultImg from "@/assets/images/icons/no-img-square.jpg";

import PaginationWithReorder from "@/views/components/pagination/PaginationWithReorder.vue";
import usePrivilegeCampaignList from "./hooks/usePrivilegeCampaignList";
import ExportButton from "@/views/components/button/ExportButton.vue";
import HistoryReportModal from "@/views/pages/report/history-report/HistoryReportModal.vue";
import {
  defaultReport,
  defaultReportFilterType,
  defaultReportCategory,
} from "@/configs/dynamic-config/dynamic-report";

export default {
  components: {
    Search,
    vSelect,
    usePrivilegeCampaignList,
    EditIcon,
    DeleteIcon,
    PaginationWithReorder,
    ExportButton,
    HistoryReportModal,
  },

  setup() {
    const {
      fields,
      loading,
      status,
      statusOption,
      privilegeCampaignList,
      filters,
      ordering,
      pagination,
      onSetValueSearch,
      onSelectFilter,
      onPageChange,
      onFilterEntity,
      resolveDateWithSeperator,
      resolveTime,
      changeCampaignStatus,
      removeCampaign,
      modalPopup,
      onOpenExportModal,
      closeReportModal,
    } = usePrivilegeCampaignList();

    return {
      DefaultImg,
      fields,
      loading,
      status,
      statusOption,
      privilegeCampaignList,
      filters,
      ordering,
      pagination,
      onSetValueSearch,
      onSelectFilter,
      onPageChange,
      onFilterEntity,
      resolveDateWithSeperator,
      resolveTime,
      changeCampaignStatus,
      removeCampaign,
      defaultReport,
      defaultReportFilterType,
      defaultReportCategory,
      modalPopup,
      onOpenExportModal,
      closeReportModal,
    };
  },
};
</script>

<style>
@import "~@/assets/css/pages/default-static-table.css";
@import "~@/assets/css/override-styles/v-select.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
@import "~@/assets/css/override-styles/status.css";
.w-50px {
  width: 50px;
}
</style>
